import Api from "../../openapi";
import useUser from "./useUser";
import { setUser } from "../../store/userSlice";
import { useDispatch } from "react-redux";
import { trackLoginSuccess } from "../../utils/analytics";
import { setAccessToken, cleanSession } from "../../utils/tokenStore";

interface IOtpLogin {
  phoneNumber: string;
  otpCode: string;
}

export default function useLogin() {
  const { getUser } = useUser();
  const dispatch = useDispatch();

  const loginWithOtp = async ({ phoneNumber, otpCode }: IOtpLogin) => {
    const res = await Api.Auth.loginWithOtp({ phoneNumber, otpCode }, { withCredentials: true });
    setAccessToken(res.data.accessToken!);
    const user = await getUser();
    dispatch(setUser(user));
    trackLoginSuccess(user);
    localStorage.removeItem("app-user-id");
    return user;
  };

  const logout = async () => {
    try {
      await Api.Auth.logout();
    } catch {
      // nothing to do
    }
    cleanSession();
  };

  return { loginWithOtp, logout };
}
